export default __webpack_public_path__ + "static/cafe_36032-003654f42881534ab3671e8f4e635942.png";